module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column resumo-subsidio",
    attrs: {
      "id": "dashboardProjetos"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deveExibirDados),
      expression: "deveExibirDados"
    }],
    staticClass: "container container_com-fundo container_com-margem"
  }, [_c('loading', {
    attrs: {
      "ativo": _vm.loading
    }
  }), _vm._v(" "), _c('alerta', {
    attrs: {
      "tipo": _vm.tipoDeAlerta,
      "texto": _vm.mensagemDeAlerta
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "boxs"
  }, _vm._l((_vm.dadosPorStatus), function(status) {
    return _c('div', {
      class: ['boxs-item', status.classeCss]
    }, [_c('div', {
      staticClass: "informacoes"
    }, [_c('h2', [_vm._v(_vm._s(status.nome) + " ")]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "valor-saldo"
    }, [_vm._v(" " + _vm._s(status.quantidade) + " ")]), _vm._v(" " + _vm._s(status.tipoDoDado))]), _vm._v(" "), _c('div', {
      staticClass: "percentual-progress"
    }, [_c('strong', [_vm._v(_vm._s(status.valorFormatado) + " - " + _vm._s(status.valorPercentual))]), _vm._v(" "), _c('span'), _vm._v("% do valor total\n          ")])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "progress progress-saldo-total"
  }, _vm._l((_vm.dadosPorStatus), function(status) {
    return (status.nome != 'Não utilizado') ? _c('div', {
      class: ['progress-bar', status.classeCss],
      style: ({
        width: ((status.valorPercentual) + "%")
      }),
      attrs: {
        "role": "progressbar",
        "aria-valuenow": "60",
        "aria-valuemin": "0",
        "aria-valuemax": "100"
      }
    }, [_c('div', {
      staticClass: "percentual"
    }, [_vm._v("\n          " + _vm._s(_vm.valorCabeNaBarra(status.valorPercentual) ? status.valorPercentual + '%' : '') + "\n        ")])]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "grafico-familias"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "area-graficos"
  }, [(!_vm.projetoEhBonusMoradia) ? _c('div', {
    staticClass: "expectativa-familias-a-atender"
  }, [_c('div', {
    staticClass: "legenda"
  }, [_c('strong', [_vm._v("Expectativa em atender mais"), _c('span', {
    staticClass: "quantidade"
  }, [_vm._v(_vm._s(_vm.quantidadeDeFamiliasQueAindaFaltamAtender) + "\n              ")]), _vm._v(" famílias")]), _vm._v(" "), _c('span', {
    staticClass: "figura nao-utilizado"
  })]), _vm._v(" "), _c('p', {
    staticClass: "texto"
  }, [_vm._v("\n            baseado no saldo "), _c('strong', [_vm._v("não utilizado")]), _vm._v(" e na média de "), _c('br'), _vm._v("valores dos subsídios atualmente\n            estimado\n            em\n            "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.valorMedioDoSubsidio))])])]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "legenda"
  }, [_c('ul', [_vm._l((_vm.dadosDaLegenda.filter(function (legenda) { return legenda.deveMostrarNaLista; })), function(legenda) {
    return _c('li', [_c('span', {
      staticClass: "figura",
      style: ({
        background: ("" + (legenda.cor))
      })
    }), _vm._v(" "), _c('span', {
      staticClass: "titulo"
    }, [_c('strong', [_vm._v(_vm._s(legenda.quantidade) + " ")]), _vm._v(" " + _vm._s(legenda.descricao) + " ")])])
  }), _vm._v(" "), _c('li', {
    staticClass: "total-atendido"
  }, [_vm._v("\n              Total de "), _c('span', [_vm._v(_vm._s(_vm.totalDeFamiliasAtendidas))]), _vm._v(" famílias já atendidas\n            ")])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "print"
  }, [_c('div', {
    staticClass: "printar-data"
  }, [_vm._v(" Impresso em " + _vm._s(new Date().toLocaleDateString('pt-BR')))])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icone-familia"
  }, [_c('i', {
    staticClass: "fa fa-users",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Subsídio por família")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grafico quantidade-familias-atendidas"
  }, [_c('canvas', {
    attrs: {
      "id": "chart",
      "width": "200",
      "height": "200"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f338bd7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/DashboardProjetos.vue
// module id = 1129
// module chunks = 1